// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1X4Jz","selects":"Documents_selects__1sfPn"};